import { render, staticRenderFns } from "./layActiveTableInfo.vue?vue&type=template&id=291789cc&scoped=true"
import script from "./layActiveTableInfo.vue?vue&type=script&lang=js"
export * from "./layActiveTableInfo.vue?vue&type=script&lang=js"
import style0 from "./layActiveTableInfo.vue?vue&type=style&index=0&id=291789cc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "291789cc",
  null
  
)

export default component.exports